import { PaginationResponse } from '@frontend/api-utils';

export function getAllValuesFromStore<T>(store: { [x: string]: PaginationResponse<T> }): T[] {
    return Object.keys(store)
        .map((key) => store[key].results)
        .flat();
}
